var map = {
	"./Agnieszka już dawno.mp3": 946,
	"./Biala armia.mp3": 9415,
	"./Bruno Mars - Locked Out Of Heaven (OFFICIAL DRILL REMIX) Prod. ewancarterr.mp3": 5681,
	"./Byłaś dla Mnie Wszystkim.mp3": 494,
	"./Cant Hold Us - Macklemore  Ryan Lewis (feat. Ray Dalton).mp3": 4631,
	"./Clarx - Shakedown [NCS Release].mp3": 6526,
	"./Danza Kuduro (DRILL SAMPLE REMIX) eyex05.mp3": 6989,
	"./Dont Worry (with Ray Dalton) (Radio Edit).mp3": 6915,
	"./Heuse & Tom Wilson - Ignite [NCS Release].mp3": 1374,
	"./Ira - Ona jest ze snu.mp3": 410,
	"./Jak Aniola Glos.mp3": 1137,
	"./KAMRAD - I Believe (Official Video).mp3": 6157,
	"./Kabe - Nad ranem (prod. Opiat).mp3": 8840,
	"./Królowa łez.mp3": 5860,
	"./LA Vision  Gigi DAgostino - Hollywood ( Official Lyric Video ).mp3": 1377,
	"./Lady Pank - Kryzysowa Narzeczona.mp3": 54,
	"./Lady Pank - Zawsze tam gdzie Ty.mp3": 416,
	"./Maneskin -Beggin.mp3": 8824,
	"./Midranger - Apocalypse [NCS Release].mp3": 4968,
	"./Minelli - Rampampam  Official Video.mp3": 9682,
	"./N3WPORT - Alive (feat. Neoni) [NCS Release].mp3": 8657,
	"./Nie Daj Sie.mp3": 152,
	"./OIO - Amerykańskie Teledyski.mp3": 7335,
	"./Ostatnia nocka ale to DRILL (Maciej Maleńczuk  Sentino feat. Yugopolis).mp3": 7340,
	"./Paranoia.mp3": 8745,
	"./ROY KNOX -  Over My Head (Feat. Mike Robert) [NCS Release].mp3": 3664,
	"./Rotary - Lubiła Tańczyć.mp3": 6237,
	"./SANAH - OCZY, ale to DRILL.mp3": 7276,
	"./SENTINO X VIKI GABOR FT. ALBERTO.mp3": 3958,
	"./Seven Nation Army - The White Stripes (Where Its ATT Remix).mp3": 438,
	"./Sexualna.mp3": 9294,
	"./Sexy Bitch (feat. Akon).mp3": 6175,
	"./She Doesnt Mind.mp3": 3793,
	"./Subtact - Want You (feat. Sara Skinner) [NCS Release].mp3": 3193,
	"./Sylwia Grzeszczak - Małe rzeczy.mp3": 7829,
	"./Taxi.mp3": 551,
	"./Timber.mp3": 2637,
	"./We Found Love.mp3": 7166,
	"./Wehikul Czasu - To Bylby Cud (2003 Remastered Version).mp3": 1143,
	"./Where Have You Been.mp3": 2297,
	"./file_example_MP3_1MG.mp3": 2309,
	"./file_example_MP3_5MG.mp3": 5361,
	"./impact.mp3": 1688,
	"./impact2.mp3": 1313,
	"./mixkit-games-worldbeat-466.mp3": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6032;